import { DivisionService } from './../../../_services/division.service';
import { UnitService } from './../../../_services/unit.service';
import { ResponseStructure } from './../../../../../../../libs/shared/auth/src/lib/auth-model';
import { LearningPathService } from './../../../_services/learning-path.service';
import { DepartmentService } from './../../../_services/department.service';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators, UntypedFormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { CategoryService } from '../../../_services/category.service';
import { CourseService } from '../../../_services/course.service';
import { GlobalService } from '../../../_services/global.service';

@Component({
  selector: 'iq-central-front-end-create-new-learning-path',
  templateUrl: './create-new-learning-path.component.html',
  styleUrls: ['./create-new-learning-path.component.scss'],
})
export class CreateNewLearningPathComponent implements OnInit {
  division: boolean;
  department: boolean;
  unit: boolean;
  learningPathForm: UntypedFormGroup;
  categories: any[] = [];
  courseCodes: any[] = [];
  subCategories: any[] = [];
  departments: any[] = [];
  divisions: any[] = [];
  units: any[] = [];
  restrictionId: any;
  courses: any[] = [];
  selectedCourses: any[] = [];
  restrictionType: any;
  selectCourses: any[] = [];
  filteredCourses: any;
  constructor(
    private fb: UntypedFormBuilder,
    private _department: DepartmentService,
    private _division: DivisionService,
    private _unit: UnitService,
    private category: CategoryService,
    private _course: CourseService,
    private global: GlobalService,
    private _learning: LearningPathService
  ) {}

  ngOnInit(): void {
    this.getCategories();
    this.getAllCourses();
    this.initLearningPath();
  }
  initLearningPath() {
    this.learningPathForm = this.fb.group({
      name: ['', [Validators.required]],
      description: ['', [Validators.required]],
      restricted: false,
    });
  }
  getSubcatecories(categoryId) {
    categoryId == null ? null : this.global.showSpinner();
    this.category.getAllSubcategories(categoryId).subscribe((res) => {
      this.global.hideSpinner();
      this.subCategories = res['responseResult'];
    });
  }

  getCategories() {
    this.global.showSpinner();
    this.category.getAllCategories().subscribe((res) => {
      this.global.hideSpinner();
      this.categories = res['responseResult'];
    });
  }

  getDepartments() {
    this.global.showSpinner();
    this._department.getAllDepartments().subscribe((res) => {
      this.global.hideSpinner();
      this.departments = res['responseResult'];
    });
  }
  getDivisions() {
    this.global.showSpinner();
    this._division.getAllDivisions().subscribe((res) => {
      this.global.hideSpinner();
      this.divisions = res['responseResult'];
    });
  }
  getUnits() {
    this.global.showSpinner();
    this._unit.getAllUnits().subscribe((res) => {
      this.global.hideSpinner();
      this.units = res['responseResult'];
    });
  }

  getAllCourses() {
    this.global.showSpinner();
    this._course.getAllCompanyCourses().subscribe((res) => {
      this.global.hideSpinner();
      this.courses = this.filteredCourses = res['responseResult']?.courses;
    });
  }

  filter(query: string) {
    this.courses = query
      ? this.filteredCourses.filter((c) =>
          c.title.toLowerCase().includes(query.toLowerCase())
        )
      : this.filteredCourses;
  }

  setRestrictedId(restrictionId, restrictionType) {
    this.restrictionId = restrictionId;
    this.restrictionType = restrictionType;
  }
  selectDeselectCourse(course) {
    this.selectCourses.includes(course)
      ? (this.selectCourses = this.selectCourses.filter((c) => c != course))
      : this.selectCourses.push(course);
  }

  addCourse() {
    this.selectedCourses = this.selectCourses;
  }
  removeCourse(course) {
    this.selectedCourses = this.selectedCourses.filter((c) => c != course);
  }
  createLearningPath() {
    this.global.showSpinner();
    this.selectedCourses.forEach((c) => {
      this.courseCodes.push(c.code);
    });
    const payload = this.learningPathForm.value;

    payload.restricted
      ? (payload.restrictionType = this.restrictionType)
      : null;
    this.restrictionId ? (payload.restrictionId = this.restrictionId) : null;
    payload.courseCodes = this.courseCodes;

    this._learning.createLearningPath(payload).subscribe({
      next: (res: ResponseStructure) => {
        this.learningPathForm.reset();
        this.selectedCourses = [];
        this.global.globalSuccessHandler(res);
      },
    });
  }
  getRestriction(restrictionType) {
    console.log(restrictionType);
    if (restrictionType === 'Department') {
      this.getDepartments();
      this.department = true;
      this.division = false;
      this.unit = false;
    } else if (restrictionType === 'Division') {
      this.getDivisions();
      this.division = true;
      this.department = false;
      this.unit = false;
    } else if (restrictionType === 'Unit') {
      this.getUnits();
      this.unit = true;
      this.department = false;
      this.division = false;
    }
  }

  rating(course) {
    var total = 0;
    for (var i in course.courseRatings) {
      total += course.courseRatings[i].rating;
    }
    const rating = total / course.courseRatings.length;
    if (rating >= 1 && rating < 2) {
      return 'one';
    } else if (rating >= 2 && rating < 3) {
      return 'two';
    } else if (rating >= 3 && rating < 4) {
      return 'three';
    } else if (rating >= 4 && rating < 5) {
      return 'four';
    } else if (rating >= 5) {
      return 'five';
    }
  }
}
